import MiniIntendedPurchaseAmount from './MiniIntendedPurchaseAmount';

export default MiniIntendedPurchaseAmount;
